import { Outlet, Link } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'
import Logo from '../components/Logo'

export default function PublicLayout() {
  const { isAuthenticated } = useAuthStore()

  return (
    <div className="min-h-screen flex flex-col bg-secondary-50">
      {/* Header */}
      <header className="bg-white border-b border-secondary-200 sticky top-0 z-50">
        <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16 items-center">
            <Logo height={40} />
            <div className="flex items-center gap-3">
              {isAuthenticated ? (
                <Link to="/dashboard" className="btn btn-accent">
                  Dashboard
                </Link>
              ) : (
                <>
                  <Link to="/login" className="btn btn-ghost text-secondary-700">
                    Sign In
                  </Link>
                  <Link to="/register" className="btn btn-accent">
                    Get Started
                  </Link>
                </>
              )}
            </div>
          </div>
        </nav>
      </header>

      {/* Main content */}
      <main className="flex-1">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="bg-primary-900 text-primary-200 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <div className="mb-4">
                <Logo height={36} to={undefined} className="brightness-0 invert" />
              </div>
              <p className="text-sm text-primary-300">
                A trusted platform for structured expertise in Health & Biomedical Sciences.
              </p>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-4">For Experts</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/register?role=talent" className="hover:text-white transition-colors">Create Profile</Link></li>
                <li><Link to="/about" className="hover:text-white transition-colors">How It Works</Link></li>
                <li><Link to="/privacy" className="hover:text-white transition-colors">Privacy</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-4">For Collaboration</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/register?role=seeker" className="hover:text-white transition-colors">Find Experts</Link></li>
                <li><Link to="/about" className="hover:text-white transition-colors">About</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-4">Company</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/about" className="hover:text-white transition-colors">About</Link></li>
                <li><Link to="/terms" className="hover:text-white transition-colors">Terms</Link></li>
                <li><Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link></li>
                <li><a href="mailto:connect@linkzon.se" className="hover:text-white transition-colors">Contact</a></li>
              </ul>
            </div>
          </div>
          <div className="mt-8 pt-8 border-t border-primary-800 text-sm text-center text-primary-400">
            <p>&copy; {new Date().getFullYear()} Linkzon. Registered in Sweden.</p>
            <p className="mt-1">
              <a href="mailto:connect@linkzon.se" className="hover:text-primary-200 transition-colors">connect@linkzon.se</a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  )
}
